// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3930":"bea67087","7843":"c1ba70cc","8556":"bea67087"}[chunkId] + ".chunk.css";
};